// Real MODO PRO assets — source of truth.
export const ASSETS = {
  studioVideo:
    "https://customer-assets-0z36b82j.emergentagent.net/job_50e61551-be25-4592-bd83-78139c8a0596/artifacts/w4owm7ky_Estudio%20modo%20pro%20.MOV",
  studioEmpty:
    "https://customer-assets-0z36b82j.emergentagent.net/job_50e61551-be25-4592-bd83-78139c8a0596/artifacts/jy9frj8r_Modo%20pro%20studio%202.jpg.jpeg",
  eldaGuests:
    "https://customer-assets-0z36b82j.emergentagent.net/job_50e61551-be25-4592-bd83-78139c8a0596/artifacts/v8rtfs68_Elda%20con%20invitados.jpg.jpeg",
  eldaHost:
    "https://customer-assets-0z36b82j.emergentagent.net/job_50e61551-be25-4592-bd83-78139c8a0596/artifacts/kfwycvt8_Elda%20Medina%20Host.jpg.jpeg",
  onePager:
    "https://customer-assets-0z36b82j.emergentagent.net/job_50e61551-be25-4592-bd83-78139c8a0596/artifacts/o43im05e_Modo_Pro_One_Pager_.jpg.jpeg",
  // Official MODO PRO logo (uploaded by user)
  logo: "https://customer-assets-0z36b82j.emergentagent.net/job_50e61551-be25-4592-bd83-78139c8a0596/artifacts/vzc4ly1j_Logo.webp",
};
